module.exports = __webpack_public_path__ + "img/mind_background_1000_th.8e363dd8.png";